import { render, staticRenderFns } from "./StoreDrug.vue?vue&type=template&id=5ab6e2c8&"
import script from "./StoreDrug.vue?vue&type=script&lang=js&"
export * from "./StoreDrug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports